export default __webpack_public_path__ + "static/media/ListForYouActive.765d8e4e.svg";